<template>
  <div :class="['col-12', 'wc-row', 'news-wc-row']" @click="goToUrl(item.url_news)">
    <div class="row ">
      <!--ROW DATE-->
      <div class="col-12 news-row news-row-date">
        <span class="news-text-date" v-if="!loading">
          {{ item.data_inizio }}
        </span>
        <BSkeleton v-else width="30%" />
      </div>
      <!--ROW OGGETTO-->
      <div class="col-12 news-row news-row-oggetto">
          <span v-if="!loading" class="news-text-oggetto">
            {{ item.oggetto }}
          </span>
        <BSkeleton v-else width="50%" />
      </div>
      <!--ROW SOMMARIO-->
      <div class="col-12 news-row news-row-sommario">
        <span v-if="!loading" :class="['news-text-sommario', initialData.truncateText ? 'truncateText' : '']" v-html="item.sommario"></span>
        <BSkeleton v-else width="75%" />
      </div>
    </div>
  </div>
</template>

<script>
import { BSkeleton } from "bootstrap-vue";
import { mapGetters } from "vuex";

export default {
  name: "Row",
  components: {
    BSkeleton,
  },
  props: {
    item: {
      type: Object,
      default: function(){
        return {};
      }
    },
    loading: {
      type: Boolean,
      default: false
    },
    initialData: {
      type: Object,
      default: function(){
        return {};
      }
    }
  },
  computed: {
    ...mapGetters("translations", [ "get__" ])
  },
  methods: {
    goToUrl(url) {
      window.location.href = url;
    }
  }
};
</script>
